module.exports = __webpack_public_path__ + "img/global-1999-postman.3a50c6b4.jpg";